import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'newDocType';

const documentTypeService = {
  getDocumentType: (id) => {
    return request({
      resource: `${baseURL}/${encodeURIComponent(id)}`,
    });
  },

  getDocumentTypes: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/documenttypes`,
      data,
    });
  },

  allDocumentTypes: () => {
    return request({
      resource: `${baseURL}/documents/allDocumentTypes`,
    });
  },

  resolvePrintReport: (documentTypeId, companyId, langCode) => {
    const pathSegments = [`${baseURL}/resolvedPrintReport`, encodeURIComponent(documentTypeId), encodeURIComponent(companyId)];

    if (langCode) {
      pathSegments.push(encodeURIComponent(langCode));
    }

    return request({
      resource: pathSegments.join('/'),
    });
  },

  updateDocumentType: (data, id) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
      formData: data instanceof FormData,
      data,
    });
  },

  uploadFile: (file, id, { userId, langCode, docDefault = false, docLangDefault = false }) => {
    const formData = new FormData();
    formData.append('files', file);
    formData.append('userId', userId);
    formData.append('langCode', langCode);
    formData.append('docDefault', docDefault);
    formData.append('docLangDefault', docLangDefault);

    return request({
      method: Methods.POST,
      resource: `${baseURL}/uploadFile/${encodeURIComponent(id)}`,
      formData: true,
      data: formData,
    });
  },

  deleteFile: (id, userId) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/deleteFile/${encodeURIComponent(id)}`,
      data: { userId },
    });
  },

  /* getDocumentTypes: () => {
    return request({
      resource: `${baseURL}/documenttypes`,
    });
  },*/
};

export default documentTypeService;
